import { oneLine } from 'common-tags';

import { CheckOk } from '@/icons';
import { NextLink } from '@/atoms';

import { routes } from '@/lib/routes';

import type { FunctionComponent } from 'react';
import type { TypeCheckoutMenuProps } from './types';

export const CheckoutMenu: FunctionComponent<TypeCheckoutMenuProps> = ({
  className = '',
  step = -1,
}: TypeCheckoutMenuProps) => (
  <div
    className={`mb:pb-0 col-span-12 flex justify-center border-b border-primary-100 py-4 lg:col-span-3 lg:mt-4 lg:border-none ${className}`}
  >
    <div className="flex w-full justify-center lg:w-fit lg:flex-col lg:justify-start">
      <div className="flex w-full flex-col-reverse items-center justify-end gap-1 lg:flex-row-reverse lg:items-start lg:gap-0">
        {step > 0 ? (
          <NextLink href={routes.checkout.datos}>
            <a className="u-body u-body--xs h-4 text-right lg:u-body--m lg:mb-14">
              Tus Datos
            </a>
          </NextLink>
        ) : (
          <p
            className={oneLine`u-body u-body--xs h-4 text-right lg:u-body--m lg:mb-14 ${
              step === 0 ? '!font-bold' : ''
            }`}
          >
            Tus Datos
          </p>
        )}
        <div className="relative flex w-full items-center justify-center overflow-hidden after:absolute after:left-[calc(50%_+_11px)] after:h-px after:w-full after:bg-black after:content-[''] lg:w-min lg:flex-col lg:items-start lg:justify-start lg:after:content-none">
          <span
            className={`inset-x-0 flex h-4 w-4 items-center justify-center rounded-full border border-black lg:mr-3 ${step === 0 ? 'bg-black' : 'bg-primary-50'}`}
          >
            {step > 0 && <CheckOk color="black" width={8} className="h-full" />}
          </span>
          <div className="bg-black lg:mx-1 lg:my-1 lg:ml-2 lg:h-[50px] lg:w-px" />
        </div>
      </div>

      <div className="flex w-full flex-col-reverse items-center justify-end gap-1 lg:flex-row-reverse lg:items-start lg:gap-0">
        {step > 1 ? (
          <NextLink href={routes.checkout.direccion}>
            <a className="u-body u-body--xs h-4 text-right lg:u-body--m lg:mb-14">
              Dirección
            </a>
          </NextLink>
        ) : (
          <p
            className={oneLine`u-body u-body--xs h-4 text-right lg:u-body--m lg:mb-14 ${
              step === 1 ? '!font-bold' : ''
            }`}
          >
            Dirección
          </p>
        )}
        <div className="relative flex w-full items-center justify-center overflow-hidden before:absolute before:right-[calc(50%_+_11px)] before:h-px before:w-1/2 before:bg-black before:content-[''] after:absolute after:left-[calc(50%_+_11px)] after:h-px after:w-1/2 after:bg-black after:content-[''] lg:w-min lg:flex-col lg:items-start lg:justify-start lg:before:content-none lg:after:content-none">
          <span
            className={`flex h-4 w-4 items-center justify-center rounded-full border border-black lg:mr-3 ${step === 1 ? 'bg-black' : 'bg-primary-50'}`}
          >
            {step > 1 && <CheckOk color="black" width={8} className="h-full" />}
          </span>
          <div className="bg-black lg:mx-1 lg:my-1 lg:ml-2 lg:h-[50px] lg:w-px" />
        </div>
      </div>

      <div className="flex w-full flex-col-reverse items-center justify-end gap-1 lg:flex-row-reverse lg:items-start lg:gap-0">
        <p
          className={oneLine`u-body u-body--xs h-4 text-right lg:u-body--m lg:mb-14 ${
            step === 2 ? '!font-bold' : ''
          }`}
        >
          Confirmación
        </p>
        <div className="relative flex w-full items-center justify-center overflow-hidden before:absolute before:right-[calc(50%_+_11px)] before:h-px before:w-1/2 before:bg-black before:content-[''] lg:w-min lg:flex-col lg:items-start lg:justify-start lg:before:content-none">
          <span
            className={`flex h-4 w-4 items-center justify-center rounded-full border border-black lg:mr-2 ${step === 2 ? 'bg-black' : 'bg-transparent'}`}
          />
        </div>
      </div>
    </div>
  </div>
);
